import { useState } from "react";

const DEFAULT_COLUMNS = [
  {
    id: "requested_date",
    label: "Requested Date",
    sortable: true,
    type: "date",
    width: "150",
    show: true,
    resizable: true,
  },
  {
    id: "ticket_number",
    label: "Ticket Number",
    sortable: true,
    type: "string",
    width: "150",
    show: true,
    resizable: true,
  },
];

const useColumns = (defaultColumns = DEFAULT_COLUMNS) => {
  const [columns, setColumns] = useState(defaultColumns);

  const handleResize = (newWidth, colId) => {
    setColumns([
      ...columns.map((column) =>
        column.id === colId && column.resizable
          ? { ...column, width: newWidth }
          : column
      ),
    ]);
  };

  const handleColumnFilterCheck = (event) => {
    const { name } = event.target;
    setColumns([
      ...columns.map((column) =>
        column.id === name ? { ...column, show: !column.show } : column
      ),
    ]);
  };
  return { columns, setColumns, handleResize, handleColumnFilterCheck };
};

export default useColumns;
